
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cookie-settings",
      function () {
        return require("private-next-pages/cookie-settings.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cookie-settings"])
      });
    }
  